<div data-at-no-results class="no-results flex flex-col justify-center items-center">
  <p class="message">
    <ng-content></ng-content>
  </p>
  <img src="{{ imgPath }}" />
</div>
